import { render, staticRenderFns } from "./live-room-settings.vue?vue&type=template&id=3123c110&scoped=true"
import script from "./live-room-settings.vue?vue&type=script&lang=js"
export * from "./live-room-settings.vue?vue&type=script&lang=js"
import style0 from "./live-room-settings.vue?vue&type=style&index=0&id=3123c110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3123c110",
  null
  
)

export default component.exports